// src/pages/Apps/AppCreate.tsx

import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { AppForm } from '@/components/forms/AppForm';
import { createApp } from '@/api/apps';
import { useQueryClient } from '@tanstack/react-query'; // ✅ 导入 queryClient
import { getCurrentDeveloperId } from '@/stores/authStore'; // ✅ 导入
import type { CreateAppRequest } from '@/types/app';

/**
 * 创建 App SDK 页面
 */
export const AppCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const developerId = getCurrentDeveloperId(); // ✅ 获取开发者 ID

  /**
   * 处理 App 创建
   */
  const handleCreate = async (values: CreateAppRequest): Promise<void> => {
    try {
      const app = await createApp(values);
      message.success(`App "${app.name}" 创建成功`);
      
      // ✅ 创建成功后无效化相关查询（添加开发者 ID）
      if (developerId) {
        queryClient.invalidateQueries({ queryKey: ['apps', developerId] });
      }
      
      navigate(`/apps/${app.id}`);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '创建失败';
      message.error(errorMessage);
    }
  };

  return (
    <div className="max-w-2xl">
      <AppForm onSubmit={handleCreate} />
    </div>
  );
};